import React from "react";
import { 
  Box, VStack, HStack, Input, Button, Text, 
  FormControl, FormLabel, Switch, Tooltip, Icon,
  Flex
} from "@chakra-ui/react";
import { FaSearch, FaInfoCircle } from "react-icons/fa";

const ExtractWebsiteData = ({
  websiteUrl,
  setWebsiteUrl,
  searchFullPage,
  setSearchFullPage,
  callApi,
  isLoading,
  accentColor,
  urlInputRef
}) => {
  return (
    <Box p={5}>
      <VStack spacing={4} align="stretch">
        <Text fontSize="lg" fontWeight="bold">Extract Website Data</Text>
        
        <FormControl>
          <Input
            placeholder="Enter website URL"
            value={websiteUrl}
            onChange={(e) => setWebsiteUrl(e.target.value)}
            size="md"
            ref={urlInputRef}
            borderRadius="md"
          />
        </FormControl>

        {/* Replaced HStack with Flex for better control */}
        <Flex 
          direction={{ base: "column", md: "row" }} 
          justifyContent="space-between" 
          alignItems={{ base: "start", md: "center" }}
          gap={3}
        >
          <FormControl display="flex" alignItems="center">
            <FormLabel htmlFor="search-full-page" mb="0" fontSize="sm">
              Search Full Page
            </FormLabel>
            <Tooltip 
              label="When enabled, extracts content from the entire page. When disabled, focuses on the main content area only."
              fontSize="sm"
              placement="top"
            >
              {/* Wrap the icon in a span to avoid the ref warning */}
              <span>
                <Icon as={FaInfoCircle} boxSize={4} color="gray.400" ml={1} />
              </span>
            </Tooltip>
            <Switch 
              id="search-full-page" 
              isChecked={searchFullPage}
              onChange={(e) => setSearchFullPage(e.target.checked)}
              colorScheme="blue"
              ml={2}
            />
          </FormControl>

          <Button
            leftIcon={<FaSearch />}
            onClick={callApi}
            colorScheme="blue"
            isLoading={isLoading}
            loadingText="Extracting"
            variant="solid"
            borderRadius="md"
            size="md"
            minWidth="180px" 
            height="40px"     
            px={4}            
          >
            Extract Content
          </Button>
        </Flex>
      </VStack>
    </Box>
  );
};

export default ExtractWebsiteData;